import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "content-shape container pt-4"
};

var _hoisted_2 = /*#__PURE__*/_createTextVNode("Back to Home");

export function render(_ctx, _cache) {
  var _component_n_button = _resolveComponent("n-button");

  var _component_router_link = _resolveComponent("router-link");

  var _component_n_result = _resolveComponent("n-result");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_n_result, {
    status: "error",
    title: "Resource not found",
    description: "The page you requested does not exist."
  }, {
    footer: _withCtx(function () {
      return [_createVNode(_component_router_link, {
        to: {
          name: 'Home'
        },
        class: "text-decoration-none"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_n_button, null, {
            default: _withCtx(function () {
              return [_hoisted_2];
            }),
            _: 1
          })];
        }),
        _: 1
      })];
    }),
    _: 1
  })]);
}